const handleRefetch = async ({ state, filterState, setIsSyncing, updateState, updateFilterState, queryClient, showToastUpdate }) => {
  if (state.selectedTab !== 'stok') return;

  const shouldResetToTop = filterState.page > 3;

  if (shouldResetToTop) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsSyncing(true);
    updateFilterState({ page: 1 });
  }

  updateState({ previousStocks: [] });

  queryClient.invalidateQueries({ queryKey: ['host-stock-list'] });

  await new Promise((resolve) => setTimeout(resolve, 1500));

  setIsSyncing(false);
  showToastUpdate();
};

export default handleRefetch;
